import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="page">
      <div className="container text-center" style={{ maxWidth: 480, margin: '80px auto' }}>
        <div style={{ fontSize: '5rem', marginBottom: 16 }}>🌍</div>
        <h1 style={{ fontSize: '5rem', color: 'var(--color-primary)', marginBottom: 8 }}>404</h1>
        <h2>Page Not Found</h2>
        <p className="text-light mt-1 mb-3">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex gap-1 justify-center">
          <Link to="/" className="btn btn-primary">Go Home</Link>
          <Link to="/browse" className="btn btn-ghost">Browse Services</Link>
        </div>
      </div>
    </div>
  );
}
